import clsx from "clsx";
import { StepDirection } from "../../types/stepDirection";
import { PlayPauseButton } from "./PlayPauseButton";
import { StepButton } from "./StepButton";

import styles from "./styles.module.css";

interface Props {
  big?: boolean;
  transulcentBackground?: boolean;
}

export const SeekControls = ({ big = false }: Props) => {
  const containerClass = clsx(styles.container, big && styles.bigContainer);

  return (
    <div className={containerClass}>
      <StepButton direction={StepDirection.backward} />
      <PlayPauseButton />
      <StepButton direction={StepDirection.forward} />
    </div>
  );
};
